import React from 'react';
import CompanyEarningsWidgetBuilder from './CompanyEarningsWidgetBuilder';
import CompanyEarningsWidgetRenderer from './CompanyEarningsWidgetRenderer';
import Preview from './Preview';
import type { WidgetDefinition } from '../../../registry';
import type { CompanyEarningsWidgetConfig } from './types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarCheck } from '@fortawesome/free-solid-svg-icons';

export { default as CompanyEarningsWidgetBuilder } from './CompanyEarningsWidgetBuilder';
export { default as CompanyEarningsWidgetRenderer } from './CompanyEarningsWidgetRenderer';
export * from './types';

export const definition: WidgetDefinition = {
  type: 'company_earnings',
  meta: {
    label: 'Company Earnings',
    icon: React.createElement(FontAwesomeIcon, { icon: faCalendarCheck }),
    description: 'Upcoming earnings date with consensus estimates and last reported actuals',
    isSystem: true,
    isCreatable: true,
    requiresAsset: true,
    dataFlow: 'display',
  },
  dataProvider: {
    widget: 'COMPANY_EARNINGS',
    params: [],
  },
  defaultSize: { w: 6, h: 5, minW: 4, minH: 4 },
  defaultConfig: () => ({} as CompanyEarningsWidgetConfig),
  Builder: CompanyEarningsWidgetBuilder,
  Renderer: CompanyEarningsWidgetRenderer,
  Preview,
};
